import Checkbox from 'expo-checkbox'
import _ from 'lodash'
import React from 'react'
import { ActivityIndicator, Alert, Platform, ScrollView, Text, TouchableOpacity, View } from 'react-native'
import EStyleSheet from 'react-native-extended-stylesheet'
import { connect } from 'react-redux'

import { selectRequest as selectRequestEmployees } from '../actions/employees'
import { selectRequest as selectRateTypes } from '../actions/rate-types'
import { selectRequest as selectRequestTickets } from '../actions/tickets'
import { selectRequest, update, delet_ } from '../actions/tickets-hours'
import { Button } from '../components/button'
import { EmployeesC } from '../components/employees-c'
import { Notice } from '../components/notice'
import { Right } from '../components/right'
import { COLORS } from '../constants/colors'
import { buildError, buildIcon, buildNavigationOptions } from '../modules/builders'
import { isAuthorizedCORLog } from '../modules/helpers'

class TicketsHoursList extends React.Component {
  static navigationOptions = ({ navigation }) => {
    const right = (
      <View
        style={{
          paddingRight: 20,
        }}
      >
        <Right
          icon={buildIcon('solid', COLORS.grayDark, 'plus-square', 30)}
          onPress={() => {
            const onPress = navigation.getParam('onPress', null)
            if (onPress) {
              onPress()
            }
          }}
        />
      </View>
    )
    const target = {
      headerRight: () => right,
      headerTitle: navigation.state.params.title ? navigation.state.params.title : '',
    }
    return buildNavigationOptions(target)
  }

  state = {
    checkboxes: {},
    statuses: {},
    isVisible: false,
  }

  componentDidMount = () => {
    this.props.navigation.setParams({
      onPress: () => {
        this.props.navigation.navigate('TicketsHoursAddForm', {
          id: this.props.navigation.getParam('id', ''),
        })
      },
    })
    const data = {
      ticket: {
        id: this.props.navigation.getParam('id', ''),
      },
    }
    this.props.dispatch(selectRequest(data))
    this.props.dispatch(selectRequestEmployees())
    if (this.props.tickets.data) {
      const ticket = _.find(this.props.tickets.data.data, this.predicate)
      if (ticket) {
        this.props.navigation.setParams({
          title: `TICKET ${ticket.number}`,
        })
      }
    }

    this.props.dispatch(selectRateTypes())
  }

  handleDelete = () => {
    Promise.all([
      _.map(
        _.filter(this.props.ticketsHours.data, (item) => this.state.checkboxes[item.id]),
        (log) => {
          const values = {
            id: log.id,
            ticket: {
              id: this.props.navigation.getParam('id', ''),
            },
          }
          return delet_(values, this.props.dispatch)
        },
      ),
    ]).then(() => {
      const data = {
        status: 'wip',
        type: 'ticket',
      }
      this.props.dispatch(selectRequestTickets(data))
      this.props.navigation.navigate('TicketsDetail', {
        id: this.props.navigation.getParam('id', ''),
      })
    })
  }

  render = () => {
    if (!this.props.tickets.data) {
      return null
    }
    this.ticket = _.find(this.props.tickets.data.data, this.predicate)
    if (!this.ticket) {
      return (
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: 'center',
            padding: 20,
          }}
        >
          <Notice failure>Invalid Ticket</Notice>
        </ScrollView>
      )
    }
    if (this.props.ticketsHours.loading) {
      return this.renderLoading()
    }
    if (this.props.ticketsHours.data !== null) {
      return this.renderData()
    }
    if (this.props.ticketsHours.exception !== null) {
      return this.renderException()
    }
    return null
  }

  renderLoading = () => {
    const styles = EStyleSheet.create({
      scrollView: {
        flexGrow: 1,
        justifyContent: 'center',
        padding: '20rem',
      },
    })
    return (
      <ScrollView contentContainerStyle={styles.scrollView}>
        <ActivityIndicator color={COLORS.orange} size="large" />
      </ScrollView>
    )
  }

  renderData = () => {
    if (!this.props.ticketsHours.data.length) {
      const styles = EStyleSheet.create({
        scrollView: {
          flexGrow: 1,
          justifyContent: 'center',
          padding: '20rem',
        },
      })
      return (
        <ScrollView contentContainerStyle={styles.scrollView}>
          <Notice>No hours logged for this ticket.</Notice>
          <TouchableOpacity
            onPress={() => {
              this.props.navigation.navigate('TicketsHoursAddForm', {
                id: this.props.navigation.getParam('id', ''),
              })
            }}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <View>
              <Button primary small>
                Add
              </Button>
            </View>
          </TouchableOpacity>
        </ScrollView>
      )
    }
    return (
      <ScrollView>
        {this.renderDates()}
        <EmployeesC
          logs={this.buildItems()}
          isVisible={this.state.isVisible}
          onPressCancel={() => {
            this.setState({ checkboxes: {}, isVisible: false })
          }}
          onPressConfirm={(logs) => {
            Promise.all([
              _.map(logs, (log) => {
                const values = {
                  ...log,
                  ticket: {
                    id: this.props.navigation.getParam('id', ''),
                  },
                }
                return update(values, this.props.dispatch)
              }),
            ]).then(() => {
              const data = {
                status: 'wip',
                type: 'ticket',
              }
              this.props.dispatch(selectRequestTickets(data))
              this.props.navigation.navigate('TicketsDetail', {
                id: this.props.navigation.getParam('id', ''),
              })
            })
            this.setState({ checkboxes: {}, isVisible: false })
          }}
          rateTypes={this.props.rateTypes}
        />
      </ScrollView>
    )
  }

  buildItems = () => {
    const filter = _.filter(this.props.ticketsHours.data, (item) => this.state.checkboxes[item.id])
    const sortBy = _.sortBy(filter, (item) => `${item.data.classification}-${item.data.employee.name}`)
    return sortBy
  }

  renderDates = () => {
    const groupBy = _.groupBy(this.props.ticketsHours.data, (item) => item.created_at)
    const pairs = _.toPairs(groupBy)
    const sortBy = _.sortBy(pairs, (pair) => pair[0])
    return sortBy.map((pair) => {
      const logs = _.filter(pair[1], (log) => !isAuthorizedCORLog(log))
      return (
        <View key={pair[0]} style={{}}>
          <View
            style={{
              backgroundColor: COLORS.grayLight,
              marginBottom: 1,
              padding: 10,
            }}
          >
            <TouchableOpacity
              onPress={() => {
                this.setState((prevState) => {
                  return {
                    statuses: {
                      ...prevState.statuses,
                      [pair[0]]: !prevState.statuses[pair[0]],
                    },
                  }
                })
              }}
            >
              <View
                style={{
                  flexDirection: 'row',
                }}
              >
                <View
                  style={{
                    flexDirection: 'row',
                    flexGrow: 1,
                    paddingRight: 10,
                  }}
                >
                  <Text
                    style={{
                      color: COLORS.grayDark,
                      fontWeight: 'bold',
                      paddingRight: 10,
                    }}
                  >
                    {pair[0]}
                  </Text>
                  {logs.length ? buildIcon('solid', COLORS.redDark, 'exclamation-triangle', 15) : null}
                </View>
                {buildIcon(
                  'solid',
                  COLORS.grayDark,
                  this.state.statuses[pair[0]] === true ? 'chevron-up' : 'chevron-down',
                  20,
                )}
              </View>
            </TouchableOpacity>
          </View>
          {this.renderItems(pair[0], pair[1])}
        </View>
      )
    })
  }

  getRateType = (slug) => {
    const rateType = this.props.rateTypes.data.find((t) => t.slug === slug)
    return rateType.name || null
  }

  renderItems = (date, items) => {
    if (this.state.statuses[date] !== true) {
      return null
    }
    const logs = _.filter(items, (item) => !isAuthorizedCORLog(item))
    const styles = EStyleSheet.create({
      viewItem: {
        flexDirection: 'row',
        padding: '10rem',
        borderBottomColor: COLORS.grayLight,
        borderBottomWidth: '1rem',
      },
      viewLeft: {
        paddingRight: '5rem',
      },
      viewRight: {
        flex: 1,
      },
      viewOne: {
        flexDirection: 'row',
        paddingBottom: '5rem',
      },
      viewName: {
        flexDirection: 'row',
        flexGrow: 1,
      },
      textName: {
        color: COLORS.grayDark,
        paddingRight: 10,
      },
      textClassification: {
        color: COLORS.grayMedium,
      },
      viewTwo: {
        flexDirection: 'row',
      },
      viewTwoInner: {
        flex: 1,
      },
      textHours: {
        color: COLORS.grayDark,
        fontSize: '13rem',
        paddingRight: '10rem',
      },
      textHoursTotal: {
        color: COLORS.grayDark,
        fontSize: '15rem',
        paddingLeft: '10rem',
        paddingTop: '3rem',
        paddingBottom: '5rem',
        fontWeight: 'bold',
      },
      textRateType: {
        color: COLORS.grayDark,
        fontSize: '13rem',
      },
      viewButtons: {
        flexDirection: 'row',
        padding: '10rem',
      },
      viewButtonsEdit: {
        display: 'flex',
        paddingRight: '5rem',
      },
      viewButtonsDelete: {
        paddingLeft: '5rem',
      },
      viewButtonsGetAuthorization: {
        padding: '30rem',
      },
    })

    const totalHours = items.reduce((a, b) => a + parseFloat(b.data.hours), 0)
    const totalHoursUnauthorized = items
      .filter((a) => a.requires_auth && !a.authorization)
      .reduce((a, b) => a + parseFloat(b.data.hours, 10), 0)

    return (
      <View>
        {_.sortBy(items, (item) => item.data.employee.name).map((item) => {
          return (
            <View key={`${item.id}`} style={styles.viewItem}>
              <View style={styles.viewLeft}>
                <Checkbox
                  color={this.state.checkboxes[`${item.id}`] === true ? COLORS.orange : COLORS.grayDark}
                  onValueChange={() => {
                    this.setState((prevState) => {
                      return {
                        checkboxes: {
                          ...prevState.checkboxes,
                          [`${item.id}`]: !prevState.checkboxes[`${item.id}`],
                        },
                      }
                    })
                  }}
                  value={this.state.checkboxes[`${item.id}`] === true}
                />
              </View>
              <View style={styles.viewRight}>
                <View style={styles.viewOne}>
                  <View style={styles.viewName}>
                    <Text style={styles.textName}>{item.data.employee.name}</Text>
                    {!isAuthorizedCORLog(item) ? buildIcon('solid', COLORS.redDark, 'exclamation-triangle', 15) : null}
                  </View>
                  <Text style={styles.textClassification}>{item.data.classification}</Text>
                </View>
                <View style={styles.viewTwo}>
                  <Text style={styles.textHours}>Hours: {parseFloat(item.data.hours).toFixed(2)}</Text>
                  <Text style={styles.textRateType}>{this.getRateType(item.data.rate_slug)}</Text>
                </View>
              </View>
            </View>
          )
        })}
        <View>
          <Text style={styles.textHoursTotal}>Total Hours: {parseFloat(totalHours).toFixed(2)}</Text>
        </View>

        <View style={styles.viewButtons}>
          <View style={styles.viewButtonsEdit}>
            <TouchableOpacity
              onPress={() => {
                this.setState({ isVisible: true })
              }}
            >
              <Button edit>Edit</Button>
            </TouchableOpacity>
          </View>
          <View style={styles.viewButtonsDelete}>
            <TouchableOpacity
              onPress={() => {
                if (Platform.OS === 'web') {
                  if (window.confirm('Are you sure you want to delete the selected items?')) {
                    this.handleDelete()
                  }
                } else {
                  Alert.alert('Delete', 'Are you sure you want to delete the selected items?', [
                    {
                      text: 'No',
                      style: 'cancel',
                    },
                    {
                      text: 'Yes',
                      onPress: () => {
                        this.handleDelete()
                      },
                    },
                  ])
                }
              }}
            >
              <Button delete>Delete</Button>
            </TouchableOpacity>
          </View>
        </View>
        {logs.length > 0 ? (
          <View style={styles.viewButtonsGetAuthorization}>
            <TouchableOpacity
              onPress={() => {
                this.props.navigation.navigate('TicketsHoursAuthorization', {
                  id: this.props.navigation.getParam('id', ''),
                  logs,
                })
              }}
            >
              <Button primary>
                Get Authorization for {logs.length} items ({totalHoursUnauthorized.toFixed(2)} hrs)
              </Button>
            </TouchableOpacity>
          </View>
        ) : null}
      </View>
    )
  }

  renderException = (exception) => {
    const styles = EStyleSheet.create({
      scrollView: {
        flexGrow: 1,
        justifyContent: 'center',
        padding: '20rem',
      },
      hoursTotal: {
        marginTop: '15rem',
        marginBottom: '15rem',
      },
    })
    return (
      <ScrollView contentContainerStyle={styles.scrollView}>
        <Notice failure>{buildError(this.props.ticketsHours.exception)}</Notice>
      </ScrollView>
    )
  }

  predicate = (item) => {
    return item.id === this.props.navigation.getParam('id', '')
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
    rateTypes: state.rateTypes,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

TicketsHoursList = connect(mapStateToProps, mapDispatchToProps)(TicketsHoursList)

export { TicketsHoursList }
